import { render, staticRenderFns } from "./region.vue?vue&type=template&id=045a9cd7"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045a9cd7')) {
      api.createRecord('045a9cd7', component.options)
    } else {
      api.reload('045a9cd7', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=045a9cd7", function () {
      api.rerender('045a9cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/brace/region.vue"
export default component.exports